"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@Const/common");
const WorkItemsSimpleTable_1 = __importDefault(require("@Components/WorkItemsSimpleTable"));
const file_review_expand_works_1 = require("@Scenes/WorkScenes/Steps/FileReviewStep/file-review-expand-works");
const FileReviewCompletedWorks = (props) => {
    const { readyWorksExpanded, expandSection, contractSection, numComplete, completedWorks } = props;
    return (react_1.default.createElement("section", { className: "items-container" },
        react_1.default.createElement("div", { className: "items-header", onClick: () => {
                readyWorksExpanded
                    ? contractSection(file_review_expand_works_1.FileReviewExpandWorks.ready)
                    : expandSection(file_review_expand_works_1.FileReviewExpandWorks.ready);
            } },
            react_1.default.createElement("p", { className: "type-title bold" },
                "Ready to Submit ( ",
                numComplete,
                " )"),
            readyWorksExpanded
                ? numComplete && react_1.default.createElement("img", { src: common_1.ICONS.minus, alt: "contract" })
                : numComplete && react_1.default.createElement("img", { src: common_1.ICONS.add, alt: "expand" })),
        readyWorksExpanded && react_1.default.createElement(WorkItemsSimpleTable_1.default, { workModelList: completedWorks, valid: true })));
};
exports.default = FileReviewCompletedWorks;
